/**
 * Created by calhosh on 7/16/2017.
 */

import {useEffect} from 'react';
import _ from 'lodash';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import {useDispatch, useSelector} from 'react-redux';
import Utility from '../../../util/utilityfunctions';
import ErrorsUtility from './index';

export default function Errors() {
	const errors = useSelector((store) => store.errors);
	const isModalOpen = useSelector((store) => store.isModalOpen);
	const dispatch = useDispatch();

	const addNotification = (level, message, autoDismissInSeconds) => {
		!isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(true, level, Utility.createRichTextElement(message), '', autoDismissInSeconds)
			);
	};

	useEffect(() => {
		// This line is commented out because it is causing the error to be cleared before it is displayed
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);
}
